import { render, staticRenderFns } from "./roleMag.vue?vue&type=template&id=62258917&scoped=true"
import script from "./roleMag.vue?vue&type=script&lang=js"
export * from "./roleMag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62258917",
  null
  
)

export default component.exports